import React, {Fragment} from "react";
import ScoutingDatatable from "./ScoutingDatatable";
import {Link} from "react-router-dom";
import SVG from "react-inlinesvg";
import SA_ConfirmDelete from "../../../../../ui/sweetalert/SA_ConfirmDelete";
import "../../../../../../assets/sass/pages/scouting/delete-confirm-modal.scss";

import share_svg from '../../../../../../assets/svg/actions/icn-share-24px.svg';
import download_report_svg from '../../../../../../assets/svg/actions/icn-download-report.svg';
import delete_svg from '../../../../../../assets/svg/actions/icn-delete-24px-grey.svg';
import chevron_rigth_svg from '../../../../../../assets/svg/actions/icn-chevron-rigth-24px.svg';

class MyScoutingsDatatable extends ScoutingDatatable {

    openShareModal = (event) => {
        event.preventDefault();
        var { openShareModal } = this.props;
        if(openShareModal)
            openShareModal();
    }

    openDeleteModal = (event) => {
        event.preventDefault();
        new SA_ConfirmDelete().fire();
    }

    openDownloadReportModal = (event) => {
        event.preventDefault();
        var { openDownloadReportModal } = this.props;
        if(openDownloadReportModal)
            openDownloadReportModal();
    }

    renderButtonsScouting = () => {
        return (
            <div className="buttons-scouting--cell">
                <Link to={'#'} onClick={this.openShareModal}><SVG src={share_svg}/></Link>
                <Link to={'#'} onClick={this.openDownloadReportModal}><SVG src={download_report_svg}/></Link>
                <Link to={'#'} onClick={this.openDeleteModal}><SVG className="gray" src={delete_svg}/></Link>
                <Link to="/my-scouting/evaluation-report" ><SVG src={chevron_rigth_svg}/></Link>
            </div>
        )
    }
}

export default MyScoutingsDatatable;
